import React from "react";
import { TableProps } from '../iTable';
import CheckboxW from '../../../wui-checkbox/src';
import { TableInterface } from "../index";

export default function multiSelectX(Table: React.ComponentClass<Partial<TableProps>> | TableInterface, _Checkbox: typeof CheckboxW) {
    const MultiSelect: React.FC<TableProps> = (props) => {
        return <Table {...props} selectType={'checkbox'}></Table>
    };

    return MultiSelect as React.ComponentClass<Partial<TableProps>> | TableInterface;
}
